export const phoneParse = (phoneString: string) => {
    const phoneBase = phoneString.split('(').join('').split(')').join('').split(' ').join('').split('-').join('');
    if(phoneBase.includes('+52')){
        return phoneBase;
    }else{
        return `+52${phoneBase}`;
    }
}